import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import type {
  EquipementInstallation,
  EtatMateriel,
  TypeDefautMateriel,
} from '../../Services/defauts-materiels';

export type CarteMateriel = EquipementInstallation & {
  icone: string;
  /** Un défaut reste actif même si aucun ticket ne lui est associé. */
  defautsActifs: TypeDefautMateriel[];
  nombreTickets: number;
  ticketsParDefaut: {
    type: TypeDefautMateriel;
    libelle: string;
    tickets: number[];
  }[];
  etat: EtatMateriel;
};

/** Vignette de présentation ; les données et les états sont fournis par le panneau. */
@Component({
  selector: 'li[app-materiel-carte]',
  imports: [RouterLink, MatMenuModule],
  templateUrl: './materiel-carte.html',
  styleUrl: './materiel-carte.css',
  host: {
    '[class]': "'carte ' + carte().etat.classe",
    '[title]': 'carte().libelle + " — " + carte().etat.libelle',
  },
})
export class MaterielCarteComponent {
  readonly carte = input.required<CarteMateriel>();
}
